module.exports = __webpack_public_path__ + "img/new-step6.294b3a07.jpg";